"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const theme_tools_1 = require("@chakra-ui/theme-tools");
const baseStyle = props => ({
    track: {
        _checked: {
            bg: (0, theme_tools_1.mode)(`${props.colorScheme}.400`, `${props.colorScheme}.200`)(props),
        },
    },
});
const defaultProps = {
    colorScheme: 'green',
};
const SwitchStyle = {
    baseStyle,
    defaultProps,
};
exports.default = SwitchStyle;
